import { DateTime, Duration } from 'luxon';
import { CustomerProduct, ProductCustomService, ProductOption } from './customer-product';
import { TimeInterval } from '../../quipli-service/location/location';
import { ProductLocationStock, ProductTrackingType, ProductType } from '../../quipli-service/product/product';

export namespace CustomerProductParsers {
  export class CustomerProductJson {
    id!: number;
    name!: string;
    hidePrices!: boolean;
    minimumOrderQuantity!: number;
    recommendedQuantity!: number;
    quantityIncrement!: number;
    minRentalDuration!: string;
    maxRentalDuration?: string;
    locationIds!: number[];
    maxQuantityAvailable!: number;
    rentalTimeSlots!: TimeInterval[];
    disabledStartDate?: string;
    disabledEndDate?: string;
    isActive!: boolean;
    description?: string;
    youtubeVideo?: string;
    allowSale!: boolean;
    allowRent!: boolean;
    preselectAddOns?: boolean;
    altTitles?: string[];
    categoryIds?: number[];
    urlKeyword!: string;
    hideSalePrices!: boolean;
    stock?: ProductLocationStock[];
    saleStock!: number;
    type!: ProductType;
    trackingType!: ProductTrackingType;
    requiresProofOfInsurance!: boolean;
    taxable!: boolean;
  }

  export function toCustomerProduct(input: CustomerProductJson): CustomerProduct {
    return {
      id: input.id,
      name: input.name,
      hidePrices: input.hidePrices,
      minimumOrderQuantity: input.minimumOrderQuantity,
      recommendedQuantity: input.recommendedQuantity,
      quantityIncrement: input.quantityIncrement,
      minRentalDuration: Duration.fromISO(input.minRentalDuration),
      maxRentalDuration: input.maxRentalDuration ? Duration.fromISO(input.maxRentalDuration) : undefined,
      locationIds: input.locationIds,
      maxQuantityAvailable: input.maxQuantityAvailable,
      rentalTimeSlots: input.rentalTimeSlots,
      disabledStartDate: input.disabledStartDate
        ? DateTime.fromISO(input.disabledStartDate, { setZone: true })
        : undefined,
      disabledEndDate: input.disabledEndDate ? DateTime.fromISO(input.disabledEndDate, { setZone: true }) : undefined,
      isActive: input.isActive,
      description: input.description,
      youtubeVideo: input.youtubeVideo,
      allowSale: input.allowSale,
      allowRent: input.allowRent,
      preselectAddOns: input.preselectAddOns,
      altTitles: input.altTitles,
      categoryIds: input.categoryIds,
      urlKeyword: input.urlKeyword,
      hideSalePrices: input.hideSalePrices,
      stock: input.stock,
      saleStock: input.saleStock,
      taxable: input.taxable,
      type: input.type,
      trackingType: input.trackingType,
      requiresProofOfInsurance: input.requiresProofOfInsurance,
    };
  }

  export class ProductOptionJson {
    id!: number;
    productId!: number;
    optionId!: number;
    name!: string;
    required!: boolean;
    values?: { id: number; name: string }[];
  }
  export class ProductCustomServiceJson {
    id!: number;
    productId!: number;
    serviceId!: number;
    name!: string;
    image?: string;
    options?: string[];
    price!: number;
  }
  export class CustomizationsJson {
    options!: ProductOptionJson[];
    services!: ProductCustomServiceJson[];
  }

  export function toCustomerProductCustomizations(input: CustomizationsJson): {
    options: ProductOption[];
    services: ProductCustomService[];
  } {
    return {
      options: input.options,
      services: input.services,
    };
  }
}
